'use client';
import { ChangeEvent, ReactNode } from 'react';
import cn from 'classnames';

import './RadioGroup.style.scss';

export type RadioButtonOptions = {
  label: ReactNode;
  disabled?: boolean;
  value: string;
};

type RadioGroupProps = {
  className?: string;
  disabled?: boolean;
  name: string;
  value?: string;
  options: RadioButtonOptions[];
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
};

function RadioGroup(props: RadioGroupProps) {
  const {
    className = '',
    disabled = false,
    onChange,
    value,
    name,
    options
  } = props;

  return (
    <div
      className={cn('RadioGroup', className)}
      role='radiogroup'
    >
      {options.map((item, index) => {
        const buttonName = `${name}-${item.value}`;
        const isChecked = item.value === value;

        return (
          <label
            className={cn('RadioGroup-field-label', 'cursor', {
              checked: isChecked,
              disabled: item.disabled
            })}
            key={index}
            htmlFor={buttonName}
            aria-disabled={disabled}
          >
            <input
              id={buttonName}
              className='RadioGroup-radio'
              type='radio'
              name={name}
              onChange={onChange}
              checked={isChecked}
              value={item.value}
              disabled={item.disabled}
            />

            {item.label}
          </label>
        );
      })}
    </div>
  );
}

export default RadioGroup;
